import RefineProcedureModal from './component';
import { withSpecialtyProcedures } from '../../../../gql';

export default withSpecialtyProcedures()(RefineProcedureModal);
